export default function (Alpine) {
  Alpine.store('creditApplicationDraft', {
    // Calculator data
    product_id: null,
    product: '', // Keep for backward compatibility and backend submission
    amount: '',
    period: '',

    // Calculated amounts and percentages
    monthly_payment: null,
    total_payment: null,
    total_interest: null,
    interest_rate: null,
    administration_fee: null,
    issuance_fee: null,
    dae: null,

    // Radio button selections
    financial_item_id: null,
    credit_history_item_id: null,

    // Personal data
    idnp: '',
    phone: '',
    privacy: false,
    credit_history: false,

    init() {
      // Use $persist for localStorage persistence
      const persistedData = localStorage.getItem('_x_creditApplicationDraft')
      if (persistedData) {
        try {
          const parsed = JSON.parse(persistedData)
          Object.assign(this, parsed)
        } catch (e) {
          // Invalid data, ignore
        }
      }

      // Watch for changes and persist
      Alpine.effect(() => {
        const data = {
          product_id: this.product_id,
          product: this.product,
          amount: this.amount,
          period: this.period,
          monthly_payment: this.monthly_payment,
          total_payment: this.total_payment,
          total_interest: this.total_interest,
          interest_rate: this.interest_rate,
          administration_fee: this.administration_fee,
          issuance_fee: this.issuance_fee,
          dae: this.dae,
          financial_item_id: this.financial_item_id,
          credit_history_item_id: this.credit_history_item_id,
          idnp: this.idnp,
          phone: this.phone,
          privacy: this.privacy,
          credit_history: this.credit_history
        }
        localStorage.setItem('_x_creditApplicationDraft', JSON.stringify(data))
      })
    },

    setFromCalculator({ product_id, product, amount, period, monthly_payment, total_payment, total_interest, interest_rate, administration_fee, issuance_fee, dae, financial_item_id, credit_history_item_id }) {
      if (product_id !== undefined) this.product_id = product_id
      if (product !== undefined) this.product = product
      if (amount !== undefined) this.amount = amount
      if (period !== undefined) this.period = period
      if (monthly_payment !== undefined) this.monthly_payment = monthly_payment
      if (total_payment !== undefined) this.total_payment = total_payment
      if (total_interest !== undefined) this.total_interest = total_interest
      if (interest_rate !== undefined) this.interest_rate = interest_rate
      if (administration_fee !== undefined) this.administration_fee = administration_fee
      if (issuance_fee !== undefined) this.issuance_fee = issuance_fee
      if (dae !== undefined) this.dae = dae
      if (financial_item_id !== undefined) this.financial_item_id = financial_item_id
      if (credit_history_item_id !== undefined) this.credit_history_item_id = credit_history_item_id
    },

    setPersonalData({ idnp, phone, privacy, credit_history }) {
      if (idnp !== undefined) this.idnp = idnp
      if (phone !== undefined) this.phone = phone
      if (privacy !== undefined) this.privacy = privacy
      if (credit_history !== undefined) this.credit_history = credit_history
    },

    reset() {
      this.product_id = null
      this.product = ''
      this.amount = ''
      this.period = ''
      this.monthly_payment = null
      this.total_payment = null
      this.total_interest = null
      this.interest_rate = null
      this.administration_fee = null
      this.issuance_fee = null
      this.dae = null
      this.financial_item_id = null
      this.credit_history_item_id = null
      this.idnp = ''
      this.phone = ''
      this.privacy = false
      this.credit_history = false
    },

    resetCalculatorData() {
      this.product_id = null
      this.product = ''
      this.amount = ''
      this.period = ''
      this.monthly_payment = null
      this.total_payment = null
      this.total_interest = null
      this.interest_rate = null
      this.administration_fee = null
      this.issuance_fee = null
      this.dae = null
      this.financial_item_id = null
      this.credit_history_item_id = null
    },

    getData() {
      return {
        product_id: this.product_id,
        product: this.product,
        amount: this.amount,
        period: this.period,
        monthly_payment: this.monthly_payment,
        total_payment: this.total_payment,
        total_interest: this.total_interest,
        interest_rate: this.interest_rate,
        administration_fee: this.administration_fee,
        issuance_fee: this.issuance_fee,
        dae: this.dae,
        financial_item_id: this.financial_item_id,
        credit_history_item_id: this.credit_history_item_id,
        idnp: this.idnp,
        phone: this.phone,
        privacy: this.privacy,
        credit_history: this.credit_history
      }
    }
  })
}
